import { s, styled } from '@vega/styled/v2'

const Card = styled.div(
  s('bg-white p-6 rounded-lg shadow-lg')
)

export default Card
